import React, { useState, useEffect } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import {
  HiOutlinePhoto,
  HiOutlineXMark,
  HiOutlineCheckCircle,
  HiOutlineFolderOpen,
} from "react-icons/hi2";

const API_URL = process.env.REACT_APP_URL_PREFIX || "";

const initialForm = {
  category: "",
  type: "",
  title: "",
  description: "",
};

const railSetuGradient =
  "linear-gradient(135deg, #063b87 0%, #0a57bb 50%, #087344 100%)";

export default function FileInsertion({
  endpoint = `${API_URL}msg/drm_documents_upload`,
  onSuccess,
}) {
  const [form, setForm] = useState(initialForm);
  const [thumbnail, setThumbnail] = useState(null);
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [thumbnailPreview, setThumbnailPreview] = useState(null);

  useEffect(() => {
    if (!thumbnail) {
      setThumbnailPreview(null);
      return;
    }

    const previewUrl = URL.createObjectURL(thumbnail);
    setThumbnailPreview(previewUrl);

    return () => URL.revokeObjectURL(previewUrl);
  }, [thumbnail]);
  const change = (e) =>
    setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const resetForm = () => {
    setForm(initialForm);
    setThumbnail(null);
    setDocuments([]);
    document.getElementById("thumbnailInput")?.value &&
      (document.getElementById("thumbnailInput").value = "");
    document.getElementById("documentInput")?.value &&
      (document.getElementById("documentInput").value = "");
  };

  const submit = async (e) => {
    e.preventDefault();

    // if (!.message.trim()) {
    //   return Swal.fire({
    //     icon: "warning",
    //     title: "Message required",
    //     text: "Please enter the message.",
    //   });
    // }

    const body = new FormData();

    Object.entries(form).forEach(([key, value]) => body.append(key, value));

    if (thumbnail) body.append("thumbnails", thumbnail);

    documents.forEach((file) => body.append("documents", file));

    try {
      setLoading(true);

      const response = await axios.post(endpoint, body);
      console.log(body);
      await Swal.fire({
        icon: "success",
        title: "Added successfully",
        text: response.data?.message || "Your message has been inserted.",
        confirmButtonColor: "#0a57bb",
      });

      resetForm();
      onSuccess?.(response.data);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Insert failed",
        text: error.response?.data?.message || error.message,
        confirmButtonColor: "#063b87",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid py-3 px-2 px-md-4">
      <div
        className="card border-0 rounded-4 overflow-hidden mx-auto"
        style={{
          maxWidth: "950px",
          boxShadow: "0 8px 30px rgba(6,59,135,0.12)",
        }}
      >
        {/* Header */}
        <div
          className="p-3 p-md-4 text-white"
          style={{ background: railSetuGradient }}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className="rounded-3 d-flex align-items-center justify-content-center border border-white border-opacity-25"
              style={{
                width: "48px",
                height: "48px",
                background: "rgba(255,255,255,0.15)",
                fontSize: "24px",
              }}
            >
              <HiOutlineFolderOpen />
            </div>

            <div className="flex-grow-1">
              <h5 className="fw-bold mb-1">Upload New File</h5>
              <small className="text-white text-opacity-75">
                Add a message and attach supporting files
              </small>
            </div>

            <span className="badge rounded-pill bg-white bg-opacity-25 border border-white border-opacity-25 px-3 py-2">
              NEW ENTRY
            </span>
          </div>
        </div>

        {/* Form */}
        <form onSubmit={submit}>
          <div className="card-body p-3 p-md-4">
            <div className="row g-3">
              {/* Category */}
              <div className="col-md">
                <label className="form-label fw-semibold text-secondary">
                  <i className="bi bi-grid me-2 text-primary" />
                  Name
                </label>
                <input
                  className="form-control form-control rounded-3"
                  name="title"
                  value={form.title}
                  onChange={change}
                  placeholder="Enter Title"
                />
              </div>{" "}
              {/* Category */}
              <div className="col-md">
                <label className="form-label fw-semibold text-secondary">
                  <i className="bi bi-grid me-2 text-primary" />
                  Category
                </label>
                <input
                  className="form-control form-control rounded-3"
                  name="category"
                  value={form.category}
                  onChange={change}
                  placeholder="Enter category"
                />
              </div>
              {/* Type */}
              <div className="col-md">
                <label className="form-label fw-semibold text-secondary">
                  <i className="bi bi-grid me-2 text-primary" />
                  Type
                </label>
                <input
                  className="form-control form-control rounded-3"
                  name="type"
                  value={form.type}
                  onChange={change}
                  placeholder="Enter category"
                />
              </div>
              {/* Description */}
              <div className="col-12">
                <label className="form-label fw-semibold text-secondary">
                  <i className="bi bi-card-text me-2 text-primary" />
                  Description
                </label>
                <textarea
                  className="form-control rounded-3"
                  rows="2"
                  name="description"
                  value={form.description}
                  onChange={change}
                  placeholder="Add a short description (optional)"
                />
              </div>
              {/* Thumbnail Upload & Preview */}
              <div className="col-md-6">
                <div className="h-100 p-3 rounded-4 border bg-light bg-opacity-50">
                  {/* Preview */}
                  {thumbnailPreview && (
                    <div
                      className="position-relative mt-3 rounded-4 overflow-hidden border bg-white"
                      style={{
                        height: "220px",
                        boxShadow: "0 4px 15px rgba(6,59,135,0.08)",
                      }}
                    >
                      <img
                        src={thumbnailPreview}
                        alt="Thumbnail Preview"
                        className="w-100 h-100"
                        style={{
                          objectFit: "contain",
                          padding: "8px",
                        }}
                      />

                      {/* Image Label */}
                      <div
                        className="position-absolute bottom-0 start-0 w-100 p-2 text-white"
                        style={{
                          background:
                            "linear-gradient(135deg, #063b87, #0a57bb, #087344)",
                        }}
                      >
                        <div className="d-flex align-items-center justify-content-between">
                          <small className="text-truncate me-2">
                            <HiOutlineCheckCircle className="me-1" />
                            {thumbnail?.name}
                          </small>

                          <button
                            type="button"
                            className="btn btn-sm btn-light rounded-circle d-flex align-items-center justify-content-center"
                            style={{ width: 28, height: 28 }}
                            onClick={() => {
                              setThumbnail(null);
                              document.getElementById("thumbnailInput").value =
                                "";
                            }}
                            title="Remove thumbnail"
                          >
                            <HiOutlineXMark size={18} />
                          </button>
                        </div>
                      </div>
                    </div>
                  )}

                  {!thumbnailPreview && (
                    <div
                      className="mt-3 rounded-4 border border-2 border-dashed d-flex flex-column align-items-center justify-content-center text-secondary"
                      style={{
                        height: "150px",
                        background: "#f8fafc",
                      }}
                    >
                      <HiOutlinePhoto size={38} className="text-primary mb-2" />
                      <small>Select an image to preview</small>
                    </div>
                  )}

                  <small className="text-muted d-block mt-2">
                    Image preview appears instantly after selection.
                  </small>
                  <label className="form-label fw-semibold text-secondary">
                    <HiOutlinePhoto className="me-2 text-primary" size={18} />
                    Thumbnail Image
                  </label>

                  <input
                    id="thumbnailInput"
                    className="form-control rounded-3"
                    type="file"
                    accept="image/*"
                    onChange={(e) => {
                      const file = e.target.files?.[0];

                      if (file && file.type.startsWith("image/")) {
                        setThumbnail(file);
                      } else {
                        setThumbnail(null);
                      }
                    }}
                  />
                </div>
              </div>
              {/* Documents */}
              <div className="col-md-6">
                <div className="h-100 p-3 rounded-3 border bg-light bg-opacity-50">
                  <label className="form-label fw-semibold text-secondary">
                    <i className="bi bi-paperclip me-2 text-success" />
                    Attach Documents
                  </label>

                  <input
                    id="documentInput"
                    className="form-control rounded-3"
                    type="file"
                    multiple
                    onChange={(e) =>
                      setDocuments(Array.from(e.target.files || []))
                    }
                  />

                  <small className="text-muted d-block mt-2">
                    PDF, Word, Excel or other files
                  </small>

                  {documents.length > 0 && (
                    <div className="mt-2 small text-success">
                      <i className="bi bi-check-circle-fill me-1" />
                      {documents.length} file(s) selected
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>

          {/* Footer Actions */}
          <div className="card-footer bg-white border-top p-3 p-md-4">
            <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
              <button
                type="button"
                className="btn btn-light border rounded-3 px-4"
                onClick={resetForm}
                disabled={loading}
              >
                <i className="bi bi-arrow-counterclockwise me-2" />
                Reset
              </button>

              <button
                type="submit"
                className="btn text-white rounded-3 px-4 py-2 fw-semibold shadow-sm"
                style={{ background: railSetuGradient }}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" />
                    Saving...
                  </>
                ) : (
                  <>
                    <i className="bi bi-cloud-arrow-up me-2" />
                    Insert Message
                  </>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
